import { render } from "./orderhall.vue?vue&type=template&id=0704b8b4&scoped=true"
import script from "./orderhall.vue?vue&type=script&lang=js"
export * from "./orderhall.vue?vue&type=script&lang=js"

import "./orderhall.vue?vue&type=style&index=0&id=0704b8b4&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0704b8b4"]])

export default __exports__